import { cloneDeep, isEqual } from 'lodash'

import { Colors, Services, getServicePathToAPI, isEmpty, joinURLPath } from '@sigma-frontend-libs/commons'
import { EOtpTemplateChannelTypes } from '@sigmasms/shared-types'

import { generateServices, globalErrorHandler, proxy, request } from '@/utils'

import render from './render'

const pathToAPI = getServicePathToAPI(Services['otp-settings/channels'])
const serviceNameViaPoint = Services['otp-settings/channels'].split('/').join('.')

export default {
  name: 'SecondCol',

  mixins: [
    proxy({ type: 'object' }),

    generateServices({
      name: Services['otp-settings/templates'],

      backendGeneration: 'nest',

      get: false,
      create: false,
      update: false,
      remove: false
    })
  ],

  data() {
    return {
      tab: undefined,
      loading: false
    }
  },

  computed: {
    normalizedProxy() {
      return this.normalizeTemplates(this.proxy)
    },

    normalizedInitProxy() {
      return this.normalizeTemplates(this.initProxy)
    },

    tabs() {
      const result = []
      if (Object.values(EOtpTemplateChannelTypes).includes(this.proxy.channelType)) {
        result.push(Services.templates)
      }

      return result.map(key => {
        return {
          key,
          title: this.getTranslate(`commons.tabs.${key}`)
        }
      })
    },

    attachDisabled() {
      return this.loading || isEqual(this.normalizedProxy, this.normalizedInitProxy)
    }
  },

  async mounted() {
    if (Object.values(EOtpTemplateChannelTypes).includes(this.proxy.channelType)) {
      this.tab = this.tabs[0]?.key
      await this.rest[Services['otp-settings/templates']].find()
    }

    this.setInitProxy()
  },

  methods: {
    watchValueHandler() {
      return
    },

    receiveValue() {
      this.proxy = cloneDeep(this.value)
    },

    setInitProxy() {
      this.initProxy = cloneDeep(this.proxy)
    },

    normalizeTemplates(value) {
      const items = value?.otpChannelTemplateSettings ?? []

      return items.filter(item => {
        return !isEmpty(item.otpTemplateSettingsId) && typeof item.priority === 'number'
      })
        .map(({ otpTemplateSettingsId, priority }) => {
          return {
            otpTemplateSettingsId,
            priority
          }
        })
    },

    async attachTemplates() {
      try {
        this.loading = true
        const data = await request.update(
          joinURLPath(pathToAPI, this.$route.params.id, 'template', 'bulk'),
          { body: { otpChannelTemplateSettings: this.normalizedProxy } }
        )
        if (data) {
          this.proxy.otpChannelTemplateSettings = data?.otpChannelTemplateSettings ?? []
          this.setInitProxy()

          this.addSnackbar({
            text: this.getTranslate(`${serviceNameViaPoint}.snackbars.templates.attached`),
            type: Colors.success
          })
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
